import { render } from "./NewCostValue.vue?vue&type=template&id=6d1009cc"
import script from "./NewCostValue.vue?vue&type=script&lang=js"
export * from "./NewCostValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__